var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileblue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2935_1219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4976 1.66797H4.99901C4.55707 1.66797 4.13323 1.84353 3.82073 2.15603C3.50823 2.46853 3.33267 2.89237 3.33267 3.33431V16.665C3.33267 17.107 3.50823 17.5308 3.82073 17.8433C4.13323 18.1558 4.55707 18.3314 4.99901 18.3314H14.9971C15.439 18.3314 15.8628 18.1558 16.1753 17.8433C16.4878 17.5308 16.6634 17.107 16.6634 16.665V5.83382L12.4976 1.66797Z",
    stroke: "#155DFC",
    strokeWidth: 1.66634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6644 1.66797V5.00065C11.6644 5.44259 11.84 5.86643 12.1525 6.17893C12.465 6.49143 12.8888 6.66699 13.3307 6.66699H16.6634",
    stroke: "#155DFC",
    strokeWidth: 1.66634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33172 7.5H6.66537",
    stroke: "#155DFC",
    strokeWidth: 1.66634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3307 10.832H6.66537",
    stroke: "#155DFC",
    strokeWidth: 1.66634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3307 14.1641H6.66537",
    stroke: "#155DFC",
    strokeWidth: 1.66634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2935_1219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9961,
    height: 19.9961,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileblue);
export default __webpack_public_path__ + "static/media/fileblue.55f82ac0d0713a8ada0c57da120ac81a.svg";
export { ForwardRef as ReactComponent };